/**
 * Recently Viewed Products
 * Stores viewed products in localStorage and renders them on product/collection pages.
 */

(function() {
  'use strict';

  var STORAGE_KEY = 'fg_recently_viewed';
  var MAX_ITEMS = 10;

  function escapeHtml(text) {
    if (typeof text !== 'string') return '';
    var map = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;' };
    return text.replace(/[&<>"']/g, function(m) { return map[m]; });
  }

  function getItems() {
    try {
      var data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      return [];
    }
  }

  function saveItems(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) { /* Storage full or unavailable */ }
  }

  function trackProduct() {
    var el = document.querySelector('[data-recently-viewed-track]');
    if (!el) return;

    var product = {
      handle: el.getAttribute('data-product-handle'),
      title: el.getAttribute('data-product-title'),
      url: el.getAttribute('data-product-url'),
      image: el.getAttribute('data-product-image'),
      price: el.getAttribute('data-product-price'),
      comparePrice: el.getAttribute('data-product-compare-price') || ''
    };

    if (!product.handle) return;

    var items = getItems();
    // Remove duplicate if exists
    items = items.filter(function(item) { return item.handle !== product.handle; });
    // Add to front
    items.unshift(product);
    // Trim to max
    if (items.length > MAX_ITEMS) items = items.slice(0, MAX_ITEMS);
    saveItems(items);
  }

  function renderProducts() {
    var container = document.querySelector('[data-recently-viewed-container]');
    if (!container) return;

    var items = getItems();
    var currentHandle = container.getAttribute('data-current-handle') || '';

    // Exclude current product
    items = items.filter(function(item) { return item.handle !== currentHandle; });

    if (items.length === 0) {
      container.style.display = 'none';
      return;
    }

    var listEl = container.querySelector('.rv__list');
    if (!listEl) return;

    // Show max 8 items
    var display = items.slice(0, 8);
    var html = '';

    display.forEach(function(item) {
      var priceHtml = '<span class="rv__price">' + escapeHtml(item.price) + '</span>';
      if (item.comparePrice) {
        priceHtml = '<span class="rv__price rv__price--sale">' + escapeHtml(item.price) + '</span>'
          + ' <s class="rv__price rv__price--compare">' + escapeHtml(item.comparePrice) + '</s>';
      }

      html += '<div class="rv__item">'
        + '<a href="' + escapeHtml(item.url) + '" class="rv__link">'
        + '<div class="rv__image-wrap">'
        + (item.image ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy" width="150" height="150">' : '')
        + '</div>'
        + '<p class="rv__title">' + escapeHtml(item.title) + '</p>'
        + '<div class="rv__price-wrap">' + priceHtml + '</div>'
        + '</a>'
        + '</div>';
    });

    listEl.innerHTML = html;
    container.style.display = 'block';
  }

  // Run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      trackProduct();
      renderProducts();
    });
  } else {
    trackProduct();
    renderProducts();
  }
})();
